import { inject } from '@angular/core';
import { type CanActivateFn, Router } from '@angular/router';
import { EnvironmentService, FeatureFlagsService } from '@big-direkt/utils/environment';
import { UserService } from '../state/user.service';

export const authForgotPasswordGuard: CanActivateFn = async (_, state) => {
    const environment = inject(EnvironmentService);
    const featureFlags = inject(FeatureFlagsService);
    const router = inject(Router);
    const userService = inject(UserService);

    const isIamEnabled = featureFlags.isFeatureEnabled('iam')();

    await userService.initializeAuthentication(); // Make sure it is initialized

    if (!userService.isAuthenticated()) {
        return isIamEnabled ? userService.getLoginUrl(state.url) : true;
    }

    if(isIamEnabled) {
        userService.changePassword();

        return true;
    }

    return router.parseUrl(environment.privatePath);
};
